import { composeMiddleware } from '../module';
import { QUEUE_EFFECT } from './constants';
import { effectActions } from './effectState';
export var queueEffectMiddleware = composeMiddleware(function () {
  return function (next) {
    return function (action) {
      if (action.type === QUEUE_EFFECT) {
        next(effectActions.queueEffect.create(action.payload));
        return;
      }

      return next(action);
    };
  };
});